module.exports = __webpack_public_path__ + "static/img/qr-wxapp-circle.6ff311e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qr-wxapp-circle.jpg
// module id = 147
// module chunks = 34